import React, { useContext, useState, useEffect } from "react";
import { GET_QUESTION_CATEGORY } from "../../../../queries";
import { useQuery, useLazyQuery } from "@apollo/client";
import { useMyOrgInfo } from "../../../../Layout/AppMain/LoginStatusContext";

import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";

export const AnswerContext = React.createContext(
  {} as {
    answer: Array<string>;
    setAnswerData: (quetion_id: string, str_num: string) => void;
    orgs: any;
    currentQuetionCategory: number | boolean;
    nextQuetion: () => void;
    previousQuetion: () => void;
    lastPage: boolean;
  }
);

type AnswerContextProps = { child: JSX.Element | "...Not Found" };

export function AnswerProvider({ child }: AnswerContextProps, myOrgId: string) {
  const { id } = useMyOrgInfo();

  const { loading, error, data } = useQuery(GET_QUESTION_CATEGORY, {
    fetchPolicy: "no-cache",
    variables: { orgId: id },
  });
  const [answer, setAnswer] = useState([""]);
  const [isFirst, setIsFirst] = useState(true);
  const [currentQuetionCategory, setCurrentQuetionCategory] = useState(0);
  const [quetionCategorNum, setQuetionCategoryNum] = useState(0);
  const [lastPage, setLastPage] = useState(false);

  function setAnswerData(quetion_id: string, str_num: string) {
    let list: any = [];
    for (let e of answer) {
      if (e[0] == quetion_id) {
        let _list = [quetion_id, str_num];
        list.push(_list);
      } else {
        list.push(e);
      }
    }
    setAnswer(list);
  }

  useEffect(() => {
    if (myOrgId || loading) {
    } else {
      alert(
        "このページを利用するには「組織登録」が必要です。\n詳しくはFAQをご覧ください。"
      );
      window.location.href = "/#/dashboards/faq";
    }
  }, []);

  function nextQuetion() {
    setCurrentQuetionCategory(currentQuetionCategory + 1);
    if (currentQuetionCategory + 2 == quetionCategorNum) {
      setLastPage(true);
    }
  }
  function previousQuetion() {
    setCurrentQuetionCategory(currentQuetionCategory - 1);
    setLastPage(false);
  }

  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    alert("セッション期限切れです");
    window.location.href = "/#/dashboards/journy";
    window.location.reload();
  }
  if (!data) return "...Not Found";

  const orgs = data.allQuetionCategory.edges;

  let ar: any = [];

  if (isFirst) {
    orgs.map((edge: any) => {
      edge.node.quetion.edges.map((array: any) => {
        let list = [];
        list[0] = array.node.id;
        list[1] = array.node.lastAnswer;
        ar = [...ar, list];
        return ar;
      });
    });
    setQuetionCategoryNum(orgs.length);
    setAnswer(ar);
    setIsFirst(!isFirst);
  }

  return (
    <AnswerContext.Provider
      value={{
        answer,
        setAnswerData,
        orgs,
        currentQuetionCategory,
        nextQuetion,
        previousQuetion,
        lastPage,
      }}
    >
      {child}
    </AnswerContext.Provider>
  );
}
